import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../basic-features/button-v2/button.component";
import * as i3 from "../../basic-features/side-modal-v2/side-modal-v2.component";
import * as i4 from "../../basic-features/icon-v2/icon.component";
import * as i5 from "./upload/upload.component";
import * as i6 from "./file-row/file-row.component";
import * as i7 from "@ngx-translate/core";
function AttachmentsV2Component_div_2_geaui_icon_v2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 11);
  }
  if (rf & 2) {
    i0.ɵɵproperty("color", "blue")("file", "16px_chevron-down")("clickable", true);
  }
}
function AttachmentsV2Component_div_2_geaui_icon_v2_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 11);
  }
  if (rf & 2) {
    i0.ɵɵproperty("color", "blue")("file", "16px_chevron-up")("clickable", true);
  }
}
function AttachmentsV2Component_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function AttachmentsV2Component_div_2_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onToggleSubHeader());
    });
    i0.ɵɵtemplate(1, AttachmentsV2Component_div_2_geaui_icon_v2_1_Template, 1, 3, "geaui-icon-v2", 10)(2, AttachmentsV2Component_div_2_geaui_icon_v2_2_Template, 1, 3, "geaui-icon-v2", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("cursor-pointer", ctx_r1.savedFiles.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.subHeaderOpen);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.subHeaderOpen);
  }
}
function AttachmentsV2Component_ng_container_3_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "geaui-file-row", 14);
    i0.ɵɵlistener("downloadAttachmentClicked", function AttachmentsV2Component_ng_container_3_span_1_Template_geaui_file_row_downloadAttachmentClicked_1_listener() {
      const file_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.downloadAttachmentClicked.emit([file_r4.id, file_r4.fileName]));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const file_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("fileId", file_r4.id)("fileName", file_r4.fileName)("fileEnding", file_r4.fileName.split(".")[1])("canDelete", file_r4.canDelete)("isLoading", ctx_r1.isFileRowLoading);
  }
}
function AttachmentsV2Component_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 12);
    i0.ɵɵtemplate(1, AttachmentsV2Component_ng_container_3_span_1_Template, 2, 5, "span", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.savedFiles);
  }
}
function AttachmentsV2Component_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵelement(5, "geaui-icon-v2", 16);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, "UI-LIB.ATTACHMENTS.UPLOAD-TO"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("file", "16px_folder");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1._targetDirectory, " ");
  }
}
function AttachmentsV2Component_ng_container_6_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "geaui-file-row", 17);
    i0.ɵɵlistener("removeFileByIndex", function AttachmentsV2Component_ng_container_6_span_1_Template_geaui_file_row_removeFileByIndex_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onRemoveFile($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const file_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("index", i_r7)("isLoading", ctx_r1.loading)("fileName", file_r6.file == null ? null : file_r6.file.name)("fileEnding", file_r6.ending)("canDelete", true);
  }
}
function AttachmentsV2Component_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AttachmentsV2Component_ng_container_6_span_1_Template, 2, 5, "span", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.files);
  }
}
function AttachmentsV2Component_ng_container_7_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "geaui-file-row", 18);
    i0.ɵɵlistener("removeFileByIndex", function AttachmentsV2Component_ng_container_7_span_1_Template_geaui_file_row_removeFileByIndex_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onRemoveFolder($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const folder_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("index", i_r10)("isLoading", ctx_r1.loading)("fileName", folder_r9.name)("canDelete", true);
  }
}
function AttachmentsV2Component_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AttachmentsV2Component_ng_container_7_span_1_Template, 2, 4, "span", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.folders);
  }
}
function AttachmentsV2Component_div_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "geaui-icon-v2", 24);
    i0.ɵɵelementStart(2, "div", 25)(3, "span", 26);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 27);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("file", "16px_warning-sign");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 3, "UI-LIB.ATTACHMENTS.FILE-UPLOAD-TOO-BIG-ERROR-TITLE"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 5, "UI-LIB.ATTACHMENTS.FILE-UPLOAD-TOO-BIG-ERROR-INFO"));
  }
}
function AttachmentsV2Component_div_9_geaui_button_v2_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-button-v2", 28);
    i0.ɵɵlistener("click", function AttachmentsV2Component_div_9_geaui_button_v2_2_Template_geaui_button_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSaveFiles());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("sending", ctx_r1.loading)("disabled", ctx_r1.loading || !ctx_r1.hasPermission || ctx_r1.files.length === 0)("flex", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", !ctx_r1.loading ? ctx_r1.saveButtonText ? ctx_r1.saveButtonText : ctx_r1.isFolderUpload ? i0.ɵɵpipeBind1(2, 4, "UI.LIB.ATTACHMENTS.SAVE-FOLDERS") : i0.ɵɵpipeBind1(3, 6, "UI.LIB.ATTACHMENTS.SAVE-FILES") : "", " ");
  }
}
function AttachmentsV2Component_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, AttachmentsV2Component_div_9_div_1_Template, 9, 7, "div", 20)(2, AttachmentsV2Component_div_9_geaui_button_v2_2_Template, 4, 8, "geaui-button-v2", 21);
    i0.ɵɵelementStart(3, "geaui-upload", 22);
    i0.ɵɵlistener("filesAdded", function AttachmentsV2Component_div_9_Template_geaui_upload_filesAdded_3_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFileChange($event));
    })("maxFileSizeExceeded", function AttachmentsV2Component_div_9_Template_geaui_upload_maxFileSizeExceeded_3_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.maxFileSizeExceeded.emit();
      return i0.ɵɵresetView(ctx_r1.onMaxFileSizeExceeded());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.fileSizeExceeded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showSaveButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hasPermission", ctx_r1.hasPermission)("maxFileSize", ctx_r1.maxFileSize)("isFolderUpload", ctx_r1.isFolderUpload);
  }
}
export class AttachmentsV2Component {
  title = 'Files';
  creatingUser = '';
  savedFiles = [];
  isFolderUpload = false;
  set showAttachmentView(showAttachmentView) {
    this._showAttachmentView = showAttachmentView;
    if (!showAttachmentView && this.removeFilesOnClose) {
      this.removeUnsavedAttachments();
    }
  }
  maxFileSize = 150000000;
  allowedFileTypes;
  loading = false;
  appendTo;
  removeFilesOnClose = true;
  saveButtonText;
  showSaveButton = true;
  showSubHeader = true;
  hasPermission = false;
  files = [];
  disableUpload = false;
  isBlobStorageUpload = false;
  set targetDirectory(targetDirectory) {
    if (targetDirectory) {
      this._targetDirectory = this.getTargetDirectoryFromPath(targetDirectory);
    }
  }
  isFileRowLoading = false;
  showCloseIcon = true;
  subHeaderOpen = false;
  filesChanged = new EventEmitter();
  closeAttachmentView = new EventEmitter();
  saveFilesClicked = new EventEmitter();
  downloadAttachmentClicked = new EventEmitter();
  maxFileSizeExceeded = new EventEmitter();
  fileSizeExceeded = false;
  folders = [];
  _showAttachmentView = false;
  _targetDirectory = '';
  ngOnInit() {
    this.subHeaderOpen = this.savedFiles.length > 0;
  }
  onFileChange(files) {
    if (files) {
      this.fileSizeExceeded = false;
      const mappedFiles = files.map(file => {
        const splitByDot = file.name?.split('.');
        const fileEnding = splitByDot[splitByDot.length - 1];
        return {
          file,
          ending: fileEnding,
          createdAt: new Date(),
          createdBy: this.creatingUser,
          isFileLoading: false
        };
      });
      this.files = [...this.files, ...mappedFiles];
      this.filesChanged.emit(this.files);
      files.forEach(file => {
        const nameSplit = file.name?.split('/');
        const folder = nameSplit.length > 1 ? nameSplit[1] : file['webkitRelativePath']?.split('/')[0];
        if (!this.folders.find(existingFolder => existingFolder.name === folder)) {
          this.folders = [...this.folders, {
            name: folder,
            canDelete: true
          }];
        }
      });
    }
  }
  onSaveFiles() {
    if (this.files.length === 0) return;
    this.saveFilesClicked.emit(this.files);
    if (this.isBlobStorageUpload) {
      this.files = [];
      this.folders = [];
    }
  }
  removeUnsavedAttachments() {
    this.files = [];
    this.filesChanged.emit(this.files);
  }
  onRemoveFile(index) {
    this.files.splice(index, 1);
    this.files = [...this.files];
    this.filesChanged.emit(this.files);
  }
  onRemoveFolder(index) {
    this.files = this.files.filter(file => (file.file?.['webkitRelativePath'] ? file.file?.['webkitRelativePath'].split('/')[0] : file.file?.name.split('/')[1]) !== this.folders[index].name);
    this.folders.splice(index, 1);
    this.folders = [...this.folders];
  }
  setTitle() {
    const fileLength = this.savedFiles.length;
    return fileLength === 0 ? this.title : `${this.title} (${fileLength})`;
  }
  onToggleSubHeader() {
    if (this.savedFiles.length === 0) return;
    this.subHeaderOpen = !this.subHeaderOpen;
  }
  getTargetDirectoryFromPath(path) {
    let parts = path.split('/');
    parts = parts.filter(part => part !== '');
    return parts[parts.length - 1];
  }
  onMaxFileSizeExceeded() {
    setTimeout(() => {
      this.fileSizeExceeded = true;
    }, 0);
  }
  static ɵfac = function AttachmentsV2Component_Factory(t) {
    return new (t || AttachmentsV2Component)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AttachmentsV2Component,
    selectors: [["geaui-attachments-v2"]],
    inputs: {
      title: "title",
      creatingUser: "creatingUser",
      savedFiles: "savedFiles",
      isFolderUpload: "isFolderUpload",
      showAttachmentView: "showAttachmentView",
      maxFileSize: "maxFileSize",
      allowedFileTypes: "allowedFileTypes",
      loading: "loading",
      appendTo: "appendTo",
      removeFilesOnClose: "removeFilesOnClose",
      saveButtonText: "saveButtonText",
      showSaveButton: "showSaveButton",
      showSubHeader: "showSubHeader",
      hasPermission: "hasPermission",
      files: "files",
      disableUpload: "disableUpload",
      isBlobStorageUpload: "isBlobStorageUpload",
      targetDirectory: "targetDirectory",
      isFileRowLoading: "isFileRowLoading",
      showCloseIcon: "showCloseIcon",
      subHeaderOpen: "subHeaderOpen"
    },
    outputs: {
      filesChanged: "filesChanged",
      closeAttachmentView: "closeAttachmentView",
      saveFilesClicked: "saveFilesClicked",
      downloadAttachmentClicked: "downloadAttachmentClicked",
      maxFileSizeExceeded: "maxFileSizeExceeded"
    },
    decls: 10,
    vars: 9,
    consts: [["data-cy", "attachment-side-modal", 3, "closeSideModal", "modalTitle", "show", "showCloseIcon"], ["side-modal-header", ""], [3, "cursor-pointer", "click", 4, "ngIf"], ["side-modal-sub-header", "", 4, "ngIf"], ["side-modal-body", ""], ["class", "upload-to-folder-area", 4, "ngIf"], [4, "ngIf"], ["side-modal-footer", ""], ["class", "attachments-footer", 4, "ngIf"], [3, "click"], [3, "color", "file", "clickable", 4, "ngIf"], [3, "color", "file", "clickable"], ["side-modal-sub-header", ""], [4, "ngFor", "ngForOf"], [3, "downloadAttachmentClicked", "fileId", "fileName", "fileEnding", "canDelete", "isLoading"], [1, "upload-to-folder-area"], ["color", "black", 1, "folder-icon", 3, "file"], [3, "removeFileByIndex", "index", "isLoading", "fileName", "fileEnding", "canDelete"], ["fileEnding", "folder", 3, "removeFileByIndex", "index", "isLoading", "fileName", "canDelete"], [1, "attachments-footer"], ["class", "file-upload-error-container", 4, "ngIf"], [3, "sending", "disabled", "flex", "click", 4, "ngIf"], [3, "filesAdded", "maxFileSizeExceeded", "hasPermission", "maxFileSize", "isFolderUpload"], [1, "file-upload-error-container"], ["color", "cancel-red", 3, "file"], [1, "file-upload-error-text"], [1, "file-upload-error-text-title"], [1, "file-upload-error-text-info"], [3, "click", "sending", "disabled", "flex"]],
    template: function AttachmentsV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "geaui-side-modal-v2", 0);
        i0.ɵɵlistener("closeSideModal", function AttachmentsV2Component_Template_geaui_side_modal_v2_closeSideModal_0_listener() {
          return ctx.closeAttachmentView.emit();
        });
        i0.ɵɵelementContainerStart(1, 1);
        i0.ɵɵtemplate(2, AttachmentsV2Component_div_2_Template, 3, 4, "div", 2);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(3, AttachmentsV2Component_ng_container_3_Template, 2, 1, "ng-container", 3);
        i0.ɵɵelementContainerStart(4, 4);
        i0.ɵɵtemplate(5, AttachmentsV2Component_div_5_Template, 7, 5, "div", 5)(6, AttachmentsV2Component_ng_container_6_Template, 2, 1, "ng-container", 6)(7, AttachmentsV2Component_ng_container_7_Template, 2, 1, "ng-container", 6);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementContainerStart(8, 7);
        i0.ɵɵtemplate(9, AttachmentsV2Component_div_9_Template, 4, 5, "div", 8);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("modalTitle", ctx.setTitle())("show", ctx._showAttachmentView)("showCloseIcon", ctx.showCloseIcon);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.loading && ctx.savedFiles.length > 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.subHeaderOpen);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isBlobStorageUpload);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.isFolderUpload);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.isFolderUpload);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.disableUpload);
      }
    },
    dependencies: [i1.NgForOf, i1.NgIf, i2.ButtonV2Component, i3.SideModalV2Component, i4.IconComponent, i5.UploadComponent, i6.FileRowComponent, i7.TranslatePipe],
    styles: [".attachments-footer[_ngcontent-%COMP%]{min-height:158px;display:flex;flex-direction:column;justify-content:space-between;gap:24px}.cursor-pointer[_ngcontent-%COMP%]{cursor:pointer}.upload-to-folder-area[_ngcontent-%COMP%]{border:2px solid var(--geaui-grey-05);margin:24px 0;padding:16px;display:flex;flex-direction:column;justify-content:space-between}.upload-to-folder-area[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:first-child{margin-bottom:16px}.upload-to-folder-area[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:last-child{display:flex;flex-direction:row}.file-upload-error-container[_ngcontent-%COMP%]{border:2px solid var(--geaui-tertiary-red-60);display:flex;align-items:center;gap:8px;padding:8px}.file-upload-error-container[_ngcontent-%COMP%]   .file-upload-error-text[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:4px}.file-upload-error-container[_ngcontent-%COMP%]   .file-upload-error-text[_ngcontent-%COMP%]   .file-upload-error-text-title[_ngcontent-%COMP%]{color:var(--geaui-tertiary-red-80);font-size:14px;font-style:normal;font-weight:500;line-height:normal}.file-upload-error-container[_ngcontent-%COMP%]   .file-upload-error-text[_ngcontent-%COMP%]   .file-upload-error-text-info[_ngcontent-%COMP%]{font-size:12px;font-style:normal;font-weight:400;line-height:140%}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AttachmentsV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-attachments-v2',
      template: "<geaui-side-modal-v2\n  [modalTitle]=\"setTitle()\"\n  [show]=\"_showAttachmentView\"\n  [showCloseIcon]=\"showCloseIcon\"\n  (closeSideModal)=\"closeAttachmentView.emit()\"\n  data-cy=\"attachment-side-modal\">\n  <ng-container side-modal-header>\n    <div *ngIf=\"!loading && savedFiles.length > 0\" [class.cursor-pointer]=\"savedFiles.length > 0\" (click)=\"onToggleSubHeader()\">\n      <geaui-icon-v2 *ngIf=\"!subHeaderOpen\" [color]=\"'blue'\" [file]=\"'16px_chevron-down'\" [clickable]=\"true\"></geaui-icon-v2>\n      <geaui-icon-v2 *ngIf=\"subHeaderOpen\" [color]=\"'blue'\" [file]=\"'16px_chevron-up'\" [clickable]=\"true\"></geaui-icon-v2>\n    </div>\n  </ng-container>\n  <ng-container *ngIf=\"subHeaderOpen\" side-modal-sub-header>\n    <span *ngFor=\"let file of savedFiles\">\n      <geaui-file-row\n        [fileId]=\"file.id\"\n        [fileName]=\"file.fileName\"\n        [fileEnding]=\"file.fileName.split('.')[1]\"\n        [canDelete]=\"file.canDelete\"\n        [isLoading]=\"isFileRowLoading\"\n        (downloadAttachmentClicked)=\"downloadAttachmentClicked.emit([file.id, file.fileName])\">\n      </geaui-file-row>\n    </span>\n  </ng-container>\n  <ng-container side-modal-body>\n    <div class=\"upload-to-folder-area\" *ngIf=\"isBlobStorageUpload\">\n      <span>{{ 'UI-LIB.ATTACHMENTS.UPLOAD-TO' | translate }}</span>\n      <span>\n        <geaui-icon-v2 class=\"folder-icon\" [file]=\"'16px_folder'\" color=\"black\"></geaui-icon-v2>\n        {{ _targetDirectory }}\n      </span>\n    </div>\n    <ng-container *ngIf=\"!isFolderUpload\">\n      <span *ngFor=\"let file of files; index as i\">\n        <geaui-file-row\n          [index]=\"i\"\n          [isLoading]=\"loading\"\n          [fileName]=\"file.file?.name\"\n          [fileEnding]=\"file.ending\"\n          [canDelete]=\"true\"\n          (removeFileByIndex)=\"onRemoveFile($event)\">\n        </geaui-file-row>\n      </span>\n    </ng-container>\n    <ng-container *ngIf=\"isFolderUpload\">\n      <span *ngFor=\"let folder of folders; index as i\">\n        <geaui-file-row\n          [index]=\"i\"\n          [isLoading]=\"loading\"\n          [fileName]=\"folder.name\"\n          [canDelete]=\"true\"\n          (removeFileByIndex)=\"onRemoveFolder($event)\"\n          fileEnding=\"folder\">\n        </geaui-file-row>\n      </span>\n    </ng-container>\n  </ng-container>\n  <ng-container side-modal-footer>\n    <div class=\"attachments-footer\" *ngIf=\"!disableUpload\">\n      <div class=\"file-upload-error-container\" *ngIf=\"fileSizeExceeded\">\n        <geaui-icon-v2 [file]=\"'16px_warning-sign'\" color=\"cancel-red\"></geaui-icon-v2>\n        <div class=\"file-upload-error-text\">\n          <span class=\"file-upload-error-text-title\">{{ 'UI-LIB.ATTACHMENTS.FILE-UPLOAD-TOO-BIG-ERROR-TITLE' | translate }}</span>\n          <span class=\"file-upload-error-text-info\">{{ 'UI-LIB.ATTACHMENTS.FILE-UPLOAD-TOO-BIG-ERROR-INFO' | translate }}</span>\n        </div>\n      </div>\n      <geaui-button-v2\n        *ngIf=\"showSaveButton\"\n        [sending]=\"loading\"\n        [disabled]=\"loading || !hasPermission || files.length === 0\"\n        [flex]=\"true\"\n        (click)=\"onSaveFiles()\">\n        {{\n          !loading\n            ? saveButtonText\n              ? saveButtonText\n              : isFolderUpload\n                ? ('UI.LIB.ATTACHMENTS.SAVE-FOLDERS' | translate)\n                : ('UI.LIB.ATTACHMENTS.SAVE-FILES' | translate)\n            : ''\n        }}\n      </geaui-button-v2>\n      <geaui-upload\n        [hasPermission]=\"hasPermission\"\n        [maxFileSize]=\"maxFileSize\"\n        [isFolderUpload]=\"isFolderUpload\"\n        (filesAdded)=\"onFileChange($event)\"\n        (maxFileSizeExceeded)=\"this.maxFileSizeExceeded.emit(); onMaxFileSizeExceeded()\">\n      </geaui-upload>\n    </div>\n  </ng-container>\n</geaui-side-modal-v2>\n",
      styles: [".attachments-footer{min-height:158px;display:flex;flex-direction:column;justify-content:space-between;gap:24px}.cursor-pointer{cursor:pointer}.upload-to-folder-area{border:2px solid var(--geaui-grey-05);margin:24px 0;padding:16px;display:flex;flex-direction:column;justify-content:space-between}.upload-to-folder-area span:first-child{margin-bottom:16px}.upload-to-folder-area span:last-child{display:flex;flex-direction:row}.file-upload-error-container{border:2px solid var(--geaui-tertiary-red-60);display:flex;align-items:center;gap:8px;padding:8px}.file-upload-error-container .file-upload-error-text{display:flex;flex-direction:column;gap:4px}.file-upload-error-container .file-upload-error-text .file-upload-error-text-title{color:var(--geaui-tertiary-red-80);font-size:14px;font-style:normal;font-weight:500;line-height:normal}.file-upload-error-container .file-upload-error-text .file-upload-error-text-info{font-size:12px;font-style:normal;font-weight:400;line-height:140%}\n"]
    }]
  }], null, {
    title: [{
      type: Input
    }],
    creatingUser: [{
      type: Input
    }],
    savedFiles: [{
      type: Input
    }],
    isFolderUpload: [{
      type: Input
    }],
    showAttachmentView: [{
      type: Input
    }],
    maxFileSize: [{
      type: Input
    }],
    allowedFileTypes: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    appendTo: [{
      type: Input
    }],
    removeFilesOnClose: [{
      type: Input
    }],
    saveButtonText: [{
      type: Input
    }],
    showSaveButton: [{
      type: Input
    }],
    showSubHeader: [{
      type: Input
    }],
    hasPermission: [{
      type: Input
    }],
    files: [{
      type: Input
    }],
    disableUpload: [{
      type: Input
    }],
    isBlobStorageUpload: [{
      type: Input
    }],
    targetDirectory: [{
      type: Input
    }],
    isFileRowLoading: [{
      type: Input
    }],
    showCloseIcon: [{
      type: Input
    }],
    subHeaderOpen: [{
      type: Input
    }],
    filesChanged: [{
      type: Output
    }],
    closeAttachmentView: [{
      type: Output
    }],
    saveFilesClicked: [{
      type: Output
    }],
    downloadAttachmentClicked: [{
      type: Output
    }],
    maxFileSizeExceeded: [{
      type: Output
    }]
  });
})();
